import { Col, Row } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Image from 'assets/images/we-are.jpg';
import styles from './Header.module.scss';

const Header = () => {
  const { t } = useTranslation();

  return (
    <Row className={styles.Container}>
      <Col className={styles.MainTextContainer} sm={24} md={12} lg={8}>
        <h3 className={styles.UpperText}>{t('pages.weAre.title')}</h3>
        <h1 className={styles.Title}>{t('pages.weAre.tricao')}</h1>
        <p className={styles.Description}>{t('pages.weAre.description')}</p>
      </Col>
      <Col className={styles.MainImageContainer} sm={24} md={12} lg={16}>
        <img className={styles.MainImage} src={Image} alt="Quines somos" />
      </Col>
    </Row>
  );
};

export default Header;
